import { Component, OnInit } from '@angular/core';
import { SetupAtivacaoService } from 'src/app/core/services/setupAtivacao.service';

@Component({
  selector: 'app-setup-ativacao',
  templateUrl: './setup-ativacao.component.html',
  styleUrls: ['./setup-ativacao.component.scss'],
})
export class SetupAtivacaoComponent implements OnInit {
  constructor(private setupAtivacaoService: SetupAtivacaoService) {}

  seriais: string = '';
  prettyEvent: string = '0';
  circularProgressiveWait = false;
  setup: { serial: string; setup: string }[] = [];
  ngOnInit(): void {}

  searchSetup() {
    this.setup = [];
    var serialList = this.seriais.split(';');
    serialList = serialList.filter((v, i, a) => a.indexOf(v) === i);
    this.setupAtivacaoService
      .setupAtivacao(serialList)
      .subscribe((response: any) => {
        try {
          if (response != '') {
            let responseJSON = JSON.parse(response);
            if (responseJSON.length > 0) {
              responseJSON.forEach((item: string) => {
                let itemJson = JSON.parse(item);
                let itemKey = Object.keys(itemJson);
                let valueJson =
                  itemJson[itemKey[0]] == ''
                    ? '{"setup":"Não encontrado"}'
                    : itemJson[itemKey[0]];

                this.setup.push({
                  serial: itemKey[0],
                  setup: valueJson,
                });
              });
            }
          }
          console.log('');
        } catch (error) {
          console.log(error);
        }
      });
  }
}
